import React from 'react'
import classnames from 'classnames'
import Loader from '@SiteComponents/Loader'
import Lock from '@Images/lock.svg'

import './Button.scss'

interface ButtonProps {
  readonly styleType: string
  readonly size: string
  readonly caption?: string
  readonly type?: 'button' | 'submit' | 'reset' | undefined
  readonly icon?: JSX.Element
  readonly iconRight?: boolean
  readonly disabled?: boolean
  readonly loader?: boolean
  readonly withLock?: boolean
  readonly iconOnly?: boolean
  readonly 'aria-describedby'?: string
  readonly 'data-testid'?: string
  onClick?(e?: any): void
}

const Button: React.FC<ButtonProps> = props => {
  const {
    styleType,
    caption,
    type,
    icon,
    disabled,
    iconRight,
    size,
    loader,
    withLock,
  } = props

  const iconOnly = !caption

  const renderCaption = () => {
    return (
      <span>
        {caption}
      </span>
    )
  }

  const renderIconLeft = () => {
    return (
      <div className="Button__icon-left">
        {!iconRight && icon}
        {iconRight && withLock && <Lock />}
      </div>
    )
  }

  const renderIconRight = () => {
    return (
      <div className="Button__icon-right">
        {iconRight && icon}
        {!iconRight && withLock && <Lock />}
      </div>
    )
  }

  const renderContent = () => {
    return (
      <React.Fragment>
        {renderIconLeft()}
        {renderCaption()}
        {renderIconRight()}
      </React.Fragment>
    )
  }

  return (
    <button
      type={type || 'button'}
      className={classnames(
        'Button',
        `Button-${styleType}`,
        `Button-${size}`,
        { 'Button__icon-only': iconOnly }
      )}
      onClick={props.onClick}
      disabled={disabled}
      aria-describedby={props['aria-describedby']}
      data-testid={props['data-testid']}
    >
      {loader ? (
        <Loader />
      ) : (renderContent())}
    </button>
  )
}

export default Button
